/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/faq'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import AskChef from '@routes/AskChef';

export const Route = createFileRoute('/faq/')({
  component: () => <CacheDataRoute component={AskChef} path='/faq' />
});
